<div class="modal-header">
  <h4 class="modal-title pull-left">{{(sellerDetail ? 'COMMON.EDIT-SELLER' : 'COMMON.ADD-SELLER') | translate}}</h4>
</div>
<div class="modal-body">
  <form [formGroup]="sellerForm" #sellerFormDir="ngForm" (ngSubmit)="submit()" style="margin-bottom: -1rem;">
    <div class="row">
      <div class="col-md-6">
        <div class="form-label-group">
          <input type="text" id="name-th" class="form-control" formControlName="nameTH"
            placeholder="{{'NORMAL.COMPANY-NAME-TH'|translate}}">
          <label for="name-th">{{'NORMAL.COMPANY-NAME-TH'|translate}}</label>
          <ng-container *ngIf="nameTH.errors?.required && sellerFormDir.submitted">
            <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-label-group">
          <input type="text" id="name-en" class="form-control" formControlName="nameEN"
            placeholder="{{'NORMAL.COMPANY-NAME-EN'|translate}}">
          <label for="name-en">{{'NORMAL.COMPANY-NAME-EN'|translate}}</label>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-label-group">
          <textarea class="form-control" id="address-th" rows="3" formControlName="addressTH"
            placeholder="{{'FILTER.ADDRESS'|translate}}"></textarea>
          <label for="address-th">{{'FILTER.ADDRESS'|translate}}</label>
          <ng-container *ngIf="addressTH.errors?.required && sellerFormDir.submitted">
            <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-label-group">
          <textarea class="form-control" id="address-en" rows="3" formControlName="addressEN"
            placeholder="{{'FILTER.ADDRESS-EN'|translate}}"></textarea>
          <label for="address-en">{{'FILTER.ADDRESS-EN'|translate}}</label>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-label-group">
          <input type="text" id="postal-code" class="form-control" formControlName="postalCode"
            placeholder="{{'DATA.DELIVERY-POSTALCODE'|translate}}">
          <label for="postal-code">{{'DATA.DELIVERY-POSTALCODE'|translate}}</label>
          <ng-container *ngIf="postalCode.errors?.required && sellerFormDir.submitted">
            <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-label-group">
          <input type="text" id="tax-id" class="form-control" formControlName="taxID"
            placeholder="{{'ISSUE-TEXT.TAX-ID'|translate}}">
          <label for="tax-id">{{'ISSUE-TEXT.TAX-ID'|translate}}</label>
          <ng-container *ngIf="taxID.errors?.required && sellerFormDir.submitted">
            <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="row align-items-center">
          <div class="col">
            <div class="form-label-group">
              <input type="text" id="branch-code" class="form-control" formControlName="branchCode"
                placeholder="{{'TABLE.BRANCH-CODE'|translate}}">
              <label for="branch-code">{{'TABLE.BRANCH-CODE'|translate}}</label>
              <ng-container *ngIf="branchCode.errors?.required && sellerFormDir.submitted">
                <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
              </ng-container>
            </div>
          </div>
          <div class="col-auto text-nowrap" style="margin-bottom: 1rem;">
            <p-checkbox class="dv-checkbox" binary="true" [(ngModel)]="isHeadOffice"
              [ngModelOptions]="{standalone: true}" (onChange)="setHeadOffice()"
              label="{{'DATA.HEAD-OFFICE'|translate}}">
            </p-checkbox>
          </div>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-label-group">
          <input type="text" id="branch-name" class="form-control" formControlName="branchName"
            placeholder="{{'TABLE.BRANCH-NAME'|translate}}">
          <label for="branch-name">{{'TABLE.BRANCH-NAME'|translate}}</label>
          <ng-container *ngIf="branchName.errors?.required && sellerFormDir.submitted">
            <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
          </ng-container>
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-label-group">
          <input type="text" id="tel-no" class="form-control" formControlName="telNo"
            placeholder="{{'TABLE.TEL-NO'|translate}}">
          <label for="branch-name">{{'TABLE.TEL-NO'|translate}}</label>
          <ng-container *ngIf="telNo.errors?.required && sellerFormDir.submitted">
            <span class="text-danger">{{ 'ERROR.REQUIRED' | translate }}</span>
          </ng-container>
        </div>
      </div>

      <div class="col-12">
        <div class="row justify-content-center mb-3">
          <div class="col-auto">
            <div class="text-center">
              <label class="d-block" for="logo">{{'NORMAL.COMPANY-LOGO'|translate}}</label>
              <input #logoDir type="file" accept=".png,.jpg" id="logo" (change)="onLogoChange($event)" hidden>
              <button type="button" class="btn btn-dv btn-clean btn-wide" (click)="logoDir.click()">
                {{'TEXT.UPLOAD-IMAGE'|translate}}</button>
            </div>
          </div>
          <div class="col">
            <div style="overflow-x: auto;">
              <app-preview-logo [logo]="logo" [detail]="previewDetail"></app-preview-logo>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer m-b-0">
  <div class="col">
    <div class="row m-b-5">
      <div class="col text-center text-red">{{ errorMessage ? errorMessage : '&nbsp;' }}</div>
    </div>
    <div class="row justify-content-center">
      <div class="col">
        <button type="button" class="btn btn-dv btn-clean btn-wide m-r-20" (click)="activeModal.close()">
          {{'COMMON.CANCEL'|translate}}</button>
      </div>
      <button type="submit" class="col-auto btn btn-dv btn-wide pull-right" (click)="sellerFormDir.onSubmit()">
        {{(sellerDetail ? 'NORMAL.EDIT' : 'TEXT.SAVE') | translate}}</button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/seller/seller-detail/seller-detail.component.html